import React from "react";
import { formatCLP } from "../../data/precios";
import { precioDesde } from "../../data/segmentos";

const FotoComparativa = ({ segmento }) => {
  const { mercado } = segmento;
  if (!mercado) return null;

  const nuestro = precioDesde(segmento);
  const mercadoTexto =
    mercado.low && mercado.high
      ? `${formatCLP(mercado.low)} – ${formatCLP(mercado.high)}${mercado.unidad ? ` por ${mercado.unidad}` : ""}`
      : "Sin precio público";

  return (
    <section className="bg-sand-100 py-16 md:py-20">
      <div className="container-page">
        <h2 className="section-title max-w-2xl">Lo que cobra el mercado, al lado.</h2>
        <p className="section-copy mt-4 max-w-2xl">
          {mercado.nota} Fuente: {mercado.fuente}.
        </p>
        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          <div className="rounded-2xl bg-navy-900 p-8 text-white">
            <p className="text-sm text-sand-300">Omega Digital</p>
            <p className="mt-3 font-display text-4xl font-bold tabular-nums">{formatCLP(nuestro)}</p>
            <p className="mt-2 text-sm text-navy-200">
              {segmento.packs.length > 1 ? "Desde" : `Por ${segmento.unidad}`}, publicado en esta página.
            </p>
          </div>
          <div className="rounded-2xl border border-navy-200 bg-white p-8">
            <p className="text-sm text-navy-500">Mercado chileno</p>
            <p className="mt-3 font-display text-3xl font-bold tabular-nums text-navy-900">{mercadoTexto}</p>
            <p className="mt-2 text-sm text-navy-600">
              {mercado.sinPrecioPublico
                ? "Los estudios de este segmento no publican tarifa."
                : "Rango publicado, con la fuente arriba."}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FotoComparativa;
